import request from '@/utils/request'

// 获取栏目树
export function getTreeList(platformId) {
  return request({
    url: '/column/getTreeList?platformId=' + platformId,
    method: 'get'
  })
}

// 获取栏目详情
export function getColumnDetail(data) {
  return request({
    url: '/column/details?columnId=' + data,
    method: 'post'
  })
}

// 导航栏
export function getNavigation() {
  return request({
    url: '/navigation/all',
    method: 'post'
  })
}

// footer

export function getFooter() {
  return request({
    url: '/basic/parameters/getFootPage',
    method: 'post'
  })
}

export function getAdvert(advertType) {
  return request({
    url: `/advert/single?advertType=${advertType}`,
    method: 'post'
  })
}

// 文章列表
export function getArticleList(data) {
  return request({
    url: '/article/getPageList?' + data,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }

  })
}
// 栏目列表

export function columnList(data) {
  return request({
    url: '/navigation/single?name=' + data,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }

  })
}
// 文章详情
export function getContent(data) {
  return request({
    url: 'article/getContent?' + data,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }

  })
}
